import { Component } from '@angular/core';
import validationEngine from 'devextreme/ui/validation_engine';
import { DevExtremeModule } from 'devextreme-angular';
import { CdrUnitOfWork } from 'src/app/core/core.module';
import { CountyRate } from 'src/app/core/model/county-rate';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';

@Component({
    selector: 'app-county-rate-dialog',
    templateUrl: './county-rate-dialog.component.html',
    styleUrls: ['./county-rate-dialog.component.scss'],
    standalone: true,
    imports: [DevExtremeModule]
})
export class CountyRateDialogComponent extends BaseDialogComponent<any> {
    countyRate: CountyRate;
    displayOrder: number;

    constructor(private uow: CdrUnitOfWork) {
        super();
    }

    async ngOnInit() {
        if (!this.countyRate) this.countyRate = this.uow.countyRates.createEntity({ displayOrder: this.displayOrder });
    }

    save = async () => {
        const success = this.valid();
        if (!success) return;

        this.countyRate.name = this.countyRate.name?.trim();
        await this.uow.commit();
        this.hide({ success: true, value: this.countyRate });
    };

    cancel = async () => {
        this.uow.rollback();
        this.hide({ success: false });
    };

    valid() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            return result.isValid;
        } else return false;
    }
}
